import React from "react";
import Chart from "react-apexcharts";
import { useSubscriptionStats } from "../../../Subscriptions/hooks/useSubscriptionStats";

const SubscribersChart: React.FC = () => {
  const { newSubscriptionsPerMonth, renewalsPerMonth, activeCount, expiredCount } =
    useSubscriptionStats();

  const options: ApexCharts.ApexOptions = {
    chart: { type: "bar", height: 350, toolbar: { show: false } },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        borderRadius: 5,
        borderRadiusApplication: "end",
      },
    },
    dataLabels: { enabled: false },
    stroke: { show: true, width: 2, colors: ["transparent"] },
    xaxis: {
      categories: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
      ],
    },
    yaxis: {
      title: { text: "Subscribers" },
    },
    fill: { opacity: 1 },
    tooltip: {
      y: { formatter: (val: number) => `${val} subscribers` },
    },
  };

  const series = [
    {
      name: "New Subscriptions",
      data: newSubscriptionsPerMonth,
    },
    {
      name: "Renewals",
      data: renewalsPerMonth,
    },
  ];

  return (
    <div className="bg-card p-4 rounded-lg shadow">
      <div className="flex items-center justify-between">
        <h2 className="text-md text-white font-semibold mb-4">Subscribers Overview</h2>
        <h2 className="text-md text-white font-semibold mb-4">
          {new Date().getFullYear()}
        </h2>
      </div>

      <div className="flex items-center justify-between">
        <p className="text-sm text-white mb-2">
          Total Subscribers: {activeCount + expiredCount}
        </p>
        <p className="text-sm text-green-500 mb-2">
          Active: {activeCount}
        </p>

        <p className="text-sm text-kanema mb-2">
          Expired: {expiredCount}
        </p>
      </div>

      <Chart options={options} series={series} type="bar" height={350} />
    </div>
  );
};

export default SubscribersChart;
